/* eslint no-console: 0, no-native-reassign: 0, no-undef: 0, camelcase: 0 */
/* global Stripe, listingJSON, forterToken */

import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import {
  cloneDeep,
  filter,
  find,
  get,
  isEmpty,
  isEqual,
  map,
  merge,
  set,
  xorWith
} from 'lodash';
import moment from 'moment';
import business from 'moment-business';
import Cookie from 'react-cookie';
import { change, formValueSelector, submit, getFormValues } from 'redux-form';
import AddressFormatter from '@shopify/address';

import {
  addLocaleData,
  defineMessages,
  FormattedMessage,
  FormattedNumber,
  injectIntl
} from 'react-intl';
import en from 'react-intl/locale-data/en';
import fr from 'react-intl/locale-data/fr';
import de from 'react-intl/locale-data/de';

import { BOOKING_REQUEST_FORM } from './forms/constants';
import SegmentUtil from '../../../lib/segment_util';
import { getShowBillingForm, normalizeContracts, priceBreakdownObject } from './forms/bookingUtil';
import { getGAExperiments } from '../../../lib/ga_helpers';
import { Toggle } from '../elements-buttons/toggle-button';
import { fetchListingInfo } from '../app-main/actions/listing';
import {
  createBooking,
  createBookingFromInquiry,
  prepareBooking
} from '../app-main/actions/booking';
import { fetchInventory } from '../app-main/actions/inventory';
import { updateProgress } from '../app-main/actions/flow';
import { Profile } from '../../../api/api-profile';
import { Fees } from '../../../api/api-fees';
import currencySym from 'currency-symbol-map';
import Payments from '../../../api/api-payments';
import { Metrics } from '../../../api/api-metrics';
import Transactable from 'shared-components/flow-transactable/transactable-main';
import { BookingsRequestModal } from './bookings-request-modal';
import { parseQueryString } from '../../../lib/url_utils';
import BookingRequestForm from './forms/BookingRequestForm';
import { PageSpinner } from 'shared-components/decorators/spinner';
import Breadcrumb from '../elements-breadcrum/breadcrumb';
import StickyFooter from '../partials-footer/StickyFooter';
import Button from '../elements-buttons/Button';
import SharedIntlProviderHOC from 'shared-components/hocs/sharedIntlProviderHOC';
import { fetchEnvAddOns } from '../app-main/actions/env';
import { fetchAllFeeProfiles } from '../app-main/actions/feeProfile';
import { fetchOwnerSpacesInfo } from '../app-main/actions/spaces';
import Contracts from '../../../api/api-contracts';
import { BookingRequestSummary } from '../elements-summaries/booking-request-summary/BookingRequestSummary';
import { BookingSummary } from '../elements-summaries/booking-summary/BookingSummary';
import { fetchSpaceCountryStatus } from '../app-main/actions/space';
import { withStripeInstance } from '../elements-stripe/utils';

const setListingJSON = (listing) => {
  // global var listingJSON is being set here with listing data for segment
  listingJSON = listing;
};

const reloadErrorMeta = defineMessages({
  reloadError: {
    id: 'bkc.bookings_request_modal.reload_page',
    defaultMessage: 'Refresh the page and try again.'
  }
}).reloadError;

const reloadErrorMessage = (
  <FormattedMessage {...reloadErrorMeta} />
);

class BookingsRequestMain extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      feeCalcError: '',
      paymentInfo: false,
      processing: false,
      number_of_guests: '',
      meetsMaxAttendees: true,
      showSkeleton: false,
      showAttendeeIBWarning: false,
      credits: {},
      creditsFetched: false,
      applyCreditProcessing: false,
      suggestedCreditAutoCalcCount: 0,
      splitCheckoutAttempted: false,
      splitFailFullAttempted: false,
      controlId: '',
      splitPaymentProcessing: false,
      splitPaymentPermitted: false // whether the booking is sp eligible
    };

    this.getValueFromInput = this.getValueFromInput.bind(this);
    this.getCurrentSchedule = this.getCurrentSchedule.bind(this);
    this.getListing = this.getListing.bind(this);
    this.getIDVInfo = this.getIDVInfo.bind(this);
    this.getFeeCalc = this.getFeeCalc.bind(this);
    this.loadBookingsTrack = this.loadBookingsTrack.bind(this);
    this.successBookingsTrack = this.successBookingsTrack.bind(this);
    this.errorBookingsTrack = this.errorBookingsTrack.bind(this);
    this.validateInput = this.validateInput.bind(this);
    this.checkTransactability = this.checkTransactability.bind(this);
    this.alcoholToggleCallback = this.alcoholToggleCallback.bind(this);
    this.alcoholToggle = this.alcoholToggle.bind(this);
    this.fetchCardData = this.fetchCardData.bind(this);
    this.postBooking = this.postBooking.bind(this);
    this.checkForDuplicateBookings = this.checkForDuplicateBookings.bind(this);
    this.handleAttendeesChange = this.handleAttendeesChange.bind(this);
    this.handleAddOnChange = this.handleAddOnChange.bind(this);
    this.handleApplyCreditChange = this.handleApplyCreditChange.bind(this);
    this.getSelectedAddOns = this.getSelectedAddOns.bind(this);
    this.handleClickNext = this.handleClickNext.bind(this);
    this.handleClickBack = this.handleClickBack.bind(this);
    this.handleBillingCountryChange =
      this.handleBillingCountryChange.bind(this);
    this.handleBillingSubRegionChange =
      this.handleBillingSubRegionChange.bind(this);
    this.submitBillingAddress = this.submitBillingAddress.bind(this);
    this.submitUpdateBillingAddress = this.submitUpdateBillingAddress.bind(this);
    this.splitPaymentAnalytic = this.splitPaymentAnalytic.bind(this);
    this.handleBreadcrumbClick = this.handleBreadcrumbClick.bind(this);
    this.splitPaymentChange = this.splitPaymentChange.bind(this);
    this.requestFormErrors = this.requestFormErrors.bind(this);

    this.createPaymentMethod = this.createPaymentMethod.bind(this);
    this.handleStripeElementMounted = this.handleStripeElementMounted.bind(this);
    this.handlePaymentChange = this.handlePaymentChange.bind(this);
    this.handleExpressCheckoutMethodChange = this.handleExpressCheckoutMethodChange.bind(this);
    this.generateCheckoutBookingInfo = this.generateCheckoutBookingInfo.bind(this);
    this.generateCheckoutPayload = this.generateCheckoutPayload.bind(this);
    this.generateSetupIntentPayload = this.generateSetupIntentPayload.bind(this);
    this.createSetupIntent = this.createSetupIntent.bind(this);
    this.confirmIntent = this.confirmIntent.bind(this);
    this.getSelectedPaymentMethodId = this.getSelectedPaymentMethodId.bind(this);
    this.sendRequest = this.sendRequest.bind(this);
  }

  componentWillMount() {
    const { auth, profile, noAuthBooking, validNoAuthDate, dispatch } =
      this.props;
    // add English, French and German locales
    addLocaleData([...en, ...fr, ...de]);

    if (auth.accessToken) {
      this.fetchCardData((err, res) => {
        /**
         * If error occurs, we handle gracefully
         * and act as if there is no payment info on file,
         * still giving the user the option to fill out
         * new payment info.
         */

        let selectedPayment = null;
        let paymentInfo = [];

        if (res && Array.isArray(res) && 0 < res.length) {
          paymentInfo = res;
          selectedPayment = res[0];
        }

        this.setState({
          paymentInfo,
          selectedPayment
        });
      });

      Profile.readCredits(profile.SSOid, auth.accessToken, (response) => {
        if (200 === response.statusCode) {
          this.setState({ credits: response });
        }
        this.setState({ creditsFetched: true });
      });
    }

    if (!noAuthBooking || !validNoAuthDate) {
      dispatch(updateProgress(1));
    }

    dispatch(fetchOwnerSpacesInfo(`owner/${profile.SSOid}`, auth.accessToken));
  }

  componentDidMount() {
    const { profile, auth, dispatch } = this.props;

    analyticsIntegrations.mainFunctionsLoad();
    this.getListing();
    this.getIDVInfo();

    const locale = SharedIntlProviderHOC.getLocale();
    const localeCode = locale.split('-')[0];
    // localized list of all countries

    const localAddressFormatter = new AddressFormatter(localeCode);
    const globalAddressFormatter = new AddressFormatter('en');
    Promise.all([
      localAddressFormatter.getCountries(),
      globalAddressFormatter.getCountries()
    ]).then((values) => {
      this.setState({
        allCountries: values[0],
        globalCountries: values[1]
      });
    }).catch((err) => {
      if ('function' === typeof Bugsnag) {
        Bugsnag.notify('Shopify address lib error', err);
      }
    });

    dispatch(fetchSpaceCountryStatus(profile.SSOid, auth.accessToken));
    dispatch(fetchAllFeeProfiles(auth.accessToken, profile.SSOid)).then(
      (data) => {
        const billingAddress = filter(data, { type: 'BILLING' });
        const showBillingForm = getShowBillingForm(billingAddress);
        this.setState({
          showBillingForm
        });
      }
    );
  }

  componentDidUpdate(prevProps) {
    $.cloudinary.responsive();

    const {
      alcoholConsumed,
      spaceRentalBooking,
      riskScore,
      selectedPaymentOption,
      activityValue
    } = this.props;
    const { initialValues, noAuthBooking } = this.props;
    const alcoholChanged =
      alcoholConsumed && alcoholConsumed !== prevProps.alcoholConsumed;

    const newActivity = activityValue?.tags?.activity;
    const prevActivity = prevProps.activityValue?.tags?.activity;
    const activityChanged = newActivity !== prevActivity;

    const scheduleChanged = !isEmpty(
      xorWith(
        spaceRentalBooking.schedule,
        prevProps.spaceRentalBooking.schedule,
        isEqual
      )
    );
    const riskScoreChanged = riskScore !== prevProps.riskScore;
    const splitPaymentChanged =
      selectedPaymentOption &&
      prevProps.selectedPaymentOption &&
      selectedPaymentOption !== prevProps.selectedPaymentOption;

    // call getFeeCalc() on initial vals to displaying no auth review page
    if (
      noAuthBooking &&
      !isEqual(
        get(prevProps, 'initialValues.addOns', []),
        get(initialValues, 'addOns', [])
      )
    ) {
      this.getFeeCalc();
    }

    // Changing of alcohol or activity type changes risk score, fetch new contracts for IDV payload
    if (alcoholChanged || activityChanged) {
      this.getFeeCalc();
    }

    // If alcohol schedule or risk score have changed, retrigger IDV check
    if (alcoholChanged || activityChanged || scheduleChanged || riskScoreChanged) {
      this.getIDVInfo();
    }

    if (splitPaymentChanged) {
      this.setState({
        splitPaymentProcessing: true
      });

      this.getFeeCalc(null, false, null, null, async (feeCalcResponse) => {
        if (feeCalcResponse.error) {
          this.requestFormErrors(feeCalcResponse.error, {}, true);
          return;
        }
        this.setState({
          splitPaymentProcessing: false
        });
      });
    }
  }

  componentWillUnmount() {
    Cookie.remove('booking_attendee_tier', { path: '/' });
  }

  getValueFromInput(value, cb) {
    if ('function' === typeof cb) return cb();

    return null;
  }

  getCurrentSchedule() {
    const {
      schedule,
      scheduleValues,
      prevLoc = '',
      spaceRentalBooking,
      booking
    } = this.props;
    const scheduleInPayload = scheduleValues;
    const bookingSchedule =
      get(booking, 'booking.schedule') ||
      get(spaceRentalBooking, 'schedule', []);
    const scheduleInBooking = !isEmpty(bookingSchedule)
      ? bookingSchedule
      : undefined;
    const cookieSchedule = schedule;

    // if user has just come from listings, let's prioritize cookie
    // even if they have a booking schedule value already
    let preferredSchedule;
    if (
      -1 !== document.referrer.indexOf('listings') &&
      cookieSchedule &&
      'inbox' !== prevLoc
    ) {
      preferredSchedule = cookieSchedule;
    } else {
      preferredSchedule = scheduleInBooking || cookieSchedule || [{}];
    }

    const currentSchedule = preferredSchedule.map((hash) => {
      let returnVal;
      if (!isEmpty(hash)) {
        const date = hash.start.date;
        const day = moment(date.m + '-' + date.d + '-' + date.y, 'MM-DD-YYYY');
        if (day.isSameOrAfter(moment().startOf('day'))) {
          returnVal = hash;
        }
      }
      return returnVal;
    });

    // always prefer the payload schedule && filter for current dates
    const scheduleObj = !isEmpty(scheduleInPayload)
      ? scheduleInPayload
      : currentSchedule;
    const filteredSchedule = filter(scheduleObj, (sched) => {
      return !!sched;
    });
    const finalSchedule = filteredSchedule.length ? filteredSchedule : [{}];
    return finalSchedule;
  }

  getListing() {
    const { params, dispatch, initialValues, noAuthBooking, validNoAuthDate } =
      this.props;
    const listingId = get(params, 'listingID', '');
    const isMobile = 'mobile' === get(params, 'mobile', '');
    const {
      auth: { accessToken }
    } = this.props;
    const isInitialSchedEmpty = !get(initialValues, 'schedule[0].start.date');

    dispatch(
      fetchListingInfo(listingId, (response) => {
        if (!response.error && 'ACTIVATED' === response.status) {
          dispatch(fetchEnvAddOns());
          dispatch(
            fetchInventory(
              response.parentSpaceId,
              accessToken,
              (inventoryResp) => {
                if (!inventoryResp.error && noAuthBooking && validNoAuthDate) {
                  const reviewStep = get(inventoryResp, 'inventory', []).length
                    ? 3
                    : 2;
                  dispatch(updateProgress(reviewStep));
                }
              }
            )
          );

          setListingJSON(response);
          if (!isMobile || !isInitialSchedEmpty) {
            this.getFeeCalc(response);
          }
          const lat = get(response, 'latitude', '');
          const long = get(response, 'longitude', '');
        } else {
          location.href = `/pages/listings/${listingId}`;
        }
      })
    );
  }

  getIDVInfo() {
    const {
      params,
      auth: { accessToken },
      profile,
      alcoholConsumed,
      riskScore,
      spaceRentalBooking
    } = this.props;
    const alcohol_consumed = 'true' === alcoholConsumed;
    const ssoId = get(profile, 'SSOid', '');
    const listingId = get(params, 'listingID', '');
    const schedule = this.getCurrentSchedule();
    const activity = PSSessions.Cookies.get('saved-activity');

    const payload = {
      sso_id: ssoId,
      listing_id: listingId,
      schedule,
      alcohol_consumed,
      booking: spaceRentalBooking,
      activity
    };

    return Metrics.identityVerification(payload, accessToken, (res) => {
      const guestNeedsVerification = get(
        res,
        'data.guest_needs_verification',
        false
      );
      const risk_score = get(res, 'data.metadata.risk_score', null);

      this.setState({
        guestNeedsVerification,
        riskScore: risk_score
      });
    });
  }

  getSelectedAddOns(addOns) {
    const selectedAddOns = filter(addOns, (val) => {
      return get(val, 'info.count') && 0 < parseInt(val.info.count, 10);
    });
    // max_count is not needed for api call and will sometimes be undefined
    const cleanedAddOns = map(selectedAddOns, (addOn) => {
      delete addOn.info.max_count;
      return addOn;
    });

    return cleanedAddOns || [];
  }

  getFeeCalc(
    listingObj,
    isDateChange,
    applyCreditChangeValue,
    suggestedCredit,
    resolve
  ) {
    this.setState({
      feeCalcError: '',
      showSkeleton: true
    });

    const {
      params,
      spaceRentalBooking,
      dispatch,
      numberGuestsValue,
      applyCreditValue,
      attendeeTier,
      listing,
      addOnsValues = [],
      bookingMessage,
      hostAddOns = [],
      inventoryData,
      noAuthContracts,
      noAuthBookingContract,
      initialValues,
      booking,
      alcoholConsumed,
      selectedPaymentOption,
      activityValue
    } = this.props;

    const { credits, suggestedCreditAutoCalcCount } = this.state;
    const listingID = get(params, 'listingID', '');
    const gaClientId = analyticsIntegrations.getGoogleAnalyticsID();
    const ssoId = PSSessions.Cookies('PSUser');
    const accessToken = PSSessions.Cookies('PSAccess');
    const schedule = this.getCurrentSchedule();
    const hostSsoId = get(listingObj, 'ownerId') || get(listing, 'ownerId', '');
    const schedObj = get(schedule, '[0].start.date', {});
    const oldSchedObj = get(spaceRentalBooking, 'schedule[0].start.date', {});
    const newBkgStart = moment(
      schedObj.m + '-' + schedObj.d + '-' + schedObj.y,
      'MM-DD-YYYY'
    );
    const oldBkgStart = moment(
      oldSchedObj.m + '-' + oldSchedObj.d + '-' + oldSchedObj.y,
      'MM-DD-YYYY'
    );
    const isOldDateConciergeValid =
      2 <= business.weekDays(moment(), oldBkgStart);
    const isDateConciergeValid = 2 <= business.weekDays(moment(), newBkgStart);
    const isMobileWeb = 'mobile' === get(params, 'mobile', '');

    if (isDateConciergeValid !== isOldDateConciergeValid) {
      const dataToMap = isDateConciergeValid ? inventoryData : hostAddOns;
      // add selected add-ons for no auth retry
      const noAuthBookingAddOns = filter(noAuthContracts, { type: 'ITEM' });
      const addOns = map(dataToMap, (item) => {
        const addedItem = find(noAuthBookingAddOns, { item_id: item._id });
        if (item.visible_on_listing) {
          return {
            type: 'ITEM',
            info: {
              item_id: item._id,
              max_count: item.count,
              ...(addedItem && { count: addedItem.units })
            }
          };
        }
      });

      dispatch(change(BOOKING_REQUEST_FORM, 'addOns', addOns));
    }

    if (!schedule.length || isEmpty(schedule)) {
      return this.loadBookingsTrack();
    }

    const tierMinAttendee = get(attendeeTier, `[${listingID}].min`, 0);

    // use initial values if form values are not yet available
    const selectedAddOns = this.getSelectedAddOns(
      addOnsValues.length ? addOnsValues : initialValues.addOns
    );
    const resetAddOns = isDateChange
      ? !isOldDateConciergeValid === isDateConciergeValid
      : false;

    const creditBalance = get(credits, 'balance', 0);

    // applyCreditChangeValue is passed here on apply credit change, otherwise look at applyCreditValue prop
    const applyCreditSelected = (applyCreditChangeValue || applyCreditValue)
      .apply_credit;
    // suggestedCredit is passed here if BE provides credit suggestion, otherwise look at booking prop
    const suggestedCreditAmount = suggestedCredit
      ? get(suggestedCredit, 'subtotal_ps_credit')
      : get(
          booking,
          'booking.guest_payment_method_details.suggested.subtotal_ps_credit'
        ) ||
        get(booking, 'booking.guest_payment_method_details.subtotal_ps_credit');
    const creditToApply =
      0 <= suggestedCreditAmount ? suggestedCreditAmount : creditBalance;
    const applyCreditAmount = applyCreditSelected ? creditToApply : 0;
    const feeCalcBody = {
      host_sso_id: hostSsoId,
      guest_sso_id: ssoId,
      guest_payment_ps_credit_amount: applyCreditAmount,
      type: 'REQUEST',
      split_payment_checkout: selectedPaymentOption === 'pay_partial',
      items: [
        {
          type: 'BOOKING',
          info: {
            guest_id: ssoId,
            host_id: hostSsoId,
            listing_id: listingID,
            alcohol_consumed:
              spaceRentalBooking.alcohol_consumed ||
              noAuthBookingContract.alcohol_consumed ||
              alcoholConsumed
                ? 'true' === alcoholConsumed
                : null,
            schedule: isEmpty(schedule[0]) ? [] : schedule,
            number_of_guests:
              numberGuestsValue ||
              noAuthBookingContract.number_of_guests ||
              tierMinAttendee,
            booking_use_message:
              bookingMessage || noAuthBookingContract.booking_use_message,
            ga_client_id: gaClientId,
            attr_url: PSSessions.Cookies('PSAttrUrl'),
            attr_referrer: PSSessions.Cookies('PSAttrReferrer'),
            tags: activityValue?.tags || {}
          }
        },
        ...(resetAddOns ? [] : selectedAddOns)
      ]
    };

    return dispatch(
      prepareBooking(accessToken, feeCalcBody, async (resp) => {
        // If credits applied & quote total changes, BE provides suggested new credit amount - run fee calc again w/ suggested credit
        // Should only need to do this once. if for some reason BE comes back more than twice with suggested amounts error out to
        // avoid an infinite loop
        const suggestedCredit = get(
          resp,
          'guest_payment_method_details.suggested'
        );
        if (applyCreditSelected && suggestedCredit) {
          if (1 < suggestedCreditAutoCalcCount) {
            return this.setState({
              applyCreditProcessing: false,
              showSkeleton: false
            });
          }
          return this.setState(
            { suggestedCreditAutoCalcCount: suggestedCreditAutoCalcCount + 1 },
            () => {
              this.getFeeCalc(null, false, null, suggestedCredit);
            }
          );
        }

        if (200 === resp.statusCode) {
          const masterContract = resp.master;
          const spaceRentalContract = find(resp.children, {
            type: 'SPACE_RENTAL'
          });
          const booking = spaceRentalContract?.meta?.booking || {};
          const listing = spaceRentalContract?.meta?.listing || {};
          const splitPaymentPermitted = get(resp, 'split_payment_permitted');

          if (window.analyticsIntegrations) {
            const editedFeeObj = SegmentUtil.parseFeeObj(
              get(spaceRentalContract, 'meta.booking', {})
            );
            const editedListing =
              analyticsIntegrations.normalizeListingObj(listing);
            const guestCalculations = masterContract?.calculations?.guest || {};
            const properties = merge(
              editedFeeObj,
              editedListing,
              { optimize_experiments: JSON.stringify(getGAExperiments()) },
              { day_count: schedule.length },
              { rate_details: booking.rate_details },
              {
                split_payment: guestCalculations.split_payment,
                split_payment_permitted: splitPaymentPermitted
              }
            );
            analyticsIntegrations.bookingPriceCreated(
              properties,
              get(spaceRentalContract, 'meta.booking')
            );
          }
        }

        this.setState({
          showSkeleton: false,
          applyCreditProcessing: false,
          suggestedCreditAutoCalcCount: 0,
          splitPaymentPermitted: !!resp?.split_payment_permitted
        });

        if (resolve) {
          return resolve(resp);
        }
      })
    );
  }

  loadBookingsTrack (trackTitle) {
    const schedule = this.getCurrentSchedule();
    const { listing, publicAddOns = [] } = this.props;
    const booking = get(this.props, 'booking.booking', {});
    const currency = get(listing, 'prices[0].currency');
    const bookingContracts = get(booking, 'children', []);
    bookingContracts.push(get(booking, 'master'));

    const ssoId = PSSessions.Cookies('PSUser');
    const guestPaymentAmounts = get(booking, 'master.calculations.guest');

    const bookingObj = {
      search_keyword: PSSessions.Cookies('PSSK'),
      search_keyword_type: PSSessions.Cookies('PSSKT'),
      day_count: !schedule.length || isEmpty(schedule[0]) ? 0 : schedule.length,
      currency,
      currency_symbol: currency ? currencySym(currency) : '',
      guest_payment_amount: get(guestPaymentAmounts, 'payment', ''),
      guest_processing_percent: get(guestPaymentAmounts, 'fee_percent', ''),
      guest_processing_fee_amount: get(guestPaymentAmounts, 'fee', '')
    };

    const region = get(
      listing,
      'canonical_loc_data.administrative_area_level_1.long_name',
      ''
    );
    const country = get(listing, 'canonical_loc_data.country.long_name', '');
    const additionProps = {
      ssoId,
      content_type: 'destination',
      region,
      country
    };

    const properties = merge(
      {},
      bookingObj,
      { optimize_experiments: JSON.stringify(getGAExperiments()) },
      additionProps
    );
    analyticsIntegrations.messageTrack(
      trackTitle || 'viewed bkg request form',
      listing,
      bookingContracts,
      properties,
      publicAddOns
    );
  }

  successBookingsTrack(response) {
    const {
      listing,
      profile,
      publicAddOns = [],
      billingCountryValue,
      billingStateValue,
      selectedPaymentOption,
      guestSocialEventsPolicyAccepted
    } = this.props;
    const { SSOid } = profile;

    const bookingContracts = response.children;
    bookingContracts.push(response.master);

    const spaceRentalContract = find(response.children, {
      type: 'SPACE_RENTAL'
    });
    const socialEventPolicyAgreementRequired = get(
      spaceRentalContract,
      'meta.risk.guest_social_events_policy_agreement_required',
      false
    );
    const bookingData = get(spaceRentalContract, 'meta.booking', {});
    const masterContract = get(response, 'master', {});
    const guestPaymentAmounts = get(masterContract, 'calculations.guest');
    const bookingId = get(spaceRentalContract, 'control_id');

    const {
      schedule,
      duration,
      number_of_guests,
      alcohol_consumed,
      rate_details,
      tags
    } = bookingData;

    const guest_billing_country = billingCountryValue;
    const guest_billing_province = billingStateValue;
    const currency = get(listing, 'prices[0].currency');
    const ssoId = PSSessions.Cookies('PSUser');

    const bookingObj = {
      booking_id: bookingId,
      guest_payment_amount: guestPaymentAmounts.payment,
      subtotal_amount: get(masterContract, `amounts.primary_amount[${SSOid}]`),
      duration,
      number_of_guests,
      alcohol_consumed,
      search_keyword: PSSessions.Cookies('PSSK'),
      search_keyword_type: PSSessions.Cookies('PSSKT'),
      currency,
      guest_processing_percent: guestPaymentAmounts.fee_percent,
      guest_processing_amount: guestPaymentAmounts.fee,
      currency_symbol: currencySym(currency),
      day_count: (schedule || []).length,
      entitlement_external_id: PSSessions.Cookies('promo'),
      entitlement_id: PSSessions.Cookies('promo-id'),
      activity_submitted: (tags || {}).activity,
      is_instant_booking: get(spaceRentalContract, 'meta.is_instant_booking'),
      payment_method: response.payment_method,
      rate_details,
      ...(guest_billing_country && { guest_billing_country }),
      ...(guest_billing_province && { guest_billing_province })
    };

    const region = get(
      listing,
      'canonical_loc_data.administrative_area_level_1.long_name',
      ''
    );
    const country = get(listing, 'canonical_loc_data.country.long_name', '');
    const additionProps = {
      ssoId,
      content_type: 'destination',
      region,
      country,
      guest_social_events_policy_accepted: guestSocialEventsPolicyAccepted,
      guest_social_events_policy_agreement_required: socialEventPolicyAgreementRequired
    };

    const properties = merge(
      {},
      bookingObj,
      {
        optimize_experiments: JSON.stringify(getGAExperiments()),
        split_payment_checkout: selectedPaymentOption === 'pay_partial'
      },
      additionProps
    );
    analyticsIntegrations.messageTrack(
      'booking requested (frontend)',
      listing,
      bookingContracts,
      properties,
      publicAddOns
    );

    this.splitPaymentAnalytic(masterContract?.split_payment_checkout);
  }

  errorBookingsTrack(errorLabel, response) {
    const { listing } = this.props;
    const booking = get(this.props, 'booking.booking', {});
    const ssoId = PSSessions.Cookies('PSUser');
    const ownerId = listing.ownerId;

    const errorObj = {
      error_type: errorLabel,
      listing_id: listing._id,
      duration: booking.duration,
      booking_use_message: response.booking_use_message,
      number_of_guests: parseInt(response.number_of_guests, 10),
      alcohol_consumed: 'true' === response.alcohol_consumed,
      activity: get(response, 'tags.activity', '')
    };

    if ('function' === typeof Bugsnag) {
      Bugsnag.notify('Booking Error', response);
    }

    const properties = _.merge({}, errorObj, { ownerId, ssoId });
    analyticsIntegrations.messageTrack(
      'booking request error',
      {},
      {},
      properties
    );
  }

  validateInput(errorData, validState) {
    return validState(errorData);
  }

  checkTransactability(user, cb, closeBehavior) {
    const accessToken = PSSessions.Cookies('PSAccess');

    if (!user || !accessToken) {
      location.hash = 'a=signup&source=msg';
    } else {
      const intendedAction = cb;

      ReactDOM.render(
        <SharedIntlProviderHOC>
          <Transactable
            user={user}
            intendedAction={intendedAction}
            closeBehavior={closeBehavior}
          />
        </SharedIntlProviderHOC>,
        document.getElementById('modal-container')
      );
    }
  }

  alcoholToggleCallback(value) {
    if (value) {
      this.setState({ alcohol_consumed: value });
    }
  }

  alcoholToggle() {
    const alcoholToggle = get(
      this.props,
      'spaceRentalBooking.alcohol_consumed'
    );

    const toggleMeta = {
      onLabel: 'Yes',
      offLabel: 'No',
      onValue: 'true',
      offValue: 'false',
      title: 'Will alcohol be consumed in this activity?',
      colSize: 'col-md-7',
      selectedValue: alcoholToggle
        ? 'true'
        : false === alcoholToggle
        ? 'false'
        : false,
      changeCallback: this.alcoholToggleCallback,
      ref: 'alcohol-toggle',
      key: 'bkc-alcohol-toggle'
    };

    return (
      <div>
        <Toggle {...toggleMeta} />
        <div className='col-md-12'>
          <hr />
        </div>
      </div>
    );
  }

  fetchCardData(cb) {
    const { auth, profile } = this.props;
    const { SSOid } = profile;
    const { accessToken } = auth;

    Payments.getCustomerData(SSOid, accessToken, (res) => {
      if (400 === res.statusCode) {
        return cb(res.error);
      }

      return cb(false, res.data);
    });
  }

  submitBillingAddress(billingAddressPayload) {
    const { profile, auth } = this.props;

    Fees.createBillingAddress(
      auth.accessToken,
      profile.SSOid,
      billingAddressPayload,
      (response) => {
        if (response.error) {
          this.requestFormErrors(response.error, {}, true);
          return;
        }
        this.getFeeCalc(null, false, null, null, async (feeCalcResponse) => {
          if (feeCalcResponse.error) {
            this.requestFormErrors(feeCalcResponse.error, {}, true);
            return;
          }
        });
      }
    );
  }

  handleAttendeesChange(e) {
    const attendees = parseInt(e.target.value, 10);
    const maxAttendees = get(this.props, 'listing.number_guests', null);
    const isInstaBooking = get(
      this.props,
      'spaceRentalBooking.is_instant_booking',
      false
    );

    if (attendees > maxAttendees) {
      this.setState({
        meetsMaxAttendees: false,
        showAttendeeIBWarning: isInstaBooking
      });
    } else {
      this.setState({
        meetsMaxAttendees: true,
        showAttendeeIBWarning: false
      });
    }

    this.getFeeCalc();
  }

  handleAddOnChange() {
    this.getFeeCalc();
  }

  handleApplyCreditChange (event, value) {
    this.setState({ applyCreditProcessing: true });
    this.getFeeCalc(null, false, { apply_credit: value });
  }

  handleBillingCountryChange(e, val) {
    const { dispatch } = this.props;
    const {
      profile,
      billingCityValue,
      billingStreetValue,
      billingUnitValue,
      billingZipValue
    } = this.props;
    const billingCountry = val;

    dispatch(change(BOOKING_REQUEST_FORM, 'billing_state', ''));

    const billingAddressPayload = {
      sso_id: profile.SSOid,
      type: 'BILLING',
      country: billingCountry,
      state: '',
      city: billingCityValue,
      street: billingStreetValue,
      unit: billingUnitValue,
      zip: billingZipValue
    };

    this.submitBillingAddress(billingAddressPayload);
  }

  handleBillingSubRegionChange(e, val) {
    const {
      profile,
      billingCountryValue,
      billingCityValue,
      billingStreetValue,
      billingUnitValue,
      billingZipValue
    } = this.props;
    const billingState = val;

    let billingAddressPayload = {
      sso_id: profile.SSOid,
      type: 'BILLING',
      country: billingCountryValue,
      state: billingState,
      city: billingCityValue,
      street: billingStreetValue,
      unit: billingUnitValue,
      zip: billingZipValue
    };

    this.submitBillingAddress(billingAddressPayload);
  }

  async submitUpdateBillingAddress () {
    const {
      profile,
      auth,
      billingCountryValue,
      billingStateValue,
      billingCityValue,
      billingStreetValue,
      billingUnitValue,
      billingZipValue
    } = this.props;

    const payload = {
      sso_id: profile.SSOid,
      type: 'BILLING',
      country: billingCountryValue,
      state: billingStateValue,
      city: billingCityValue,
      street: billingStreetValue,
      unit: billingUnitValue,
      zip: billingZipValue
    };

    return new Promise((resolve, reject) => {
      Fees.createBillingAddress(auth.accessToken, profile.SSOid, payload, (response) => {
        if (200 === response.statusCode) {
          return resolve(response);
        }
        reject(response);
      });
    });
  }

  async postBooking (payload) {
    const parsedUrl = parseQueryString(location.search);
    const { auth, dispatch } = this.props;
    const { accessToken } = auth;
    const { request } = parsedUrl;
    const bookingContext = { granular_use_type: PSSessions.Cookies('PSSK') };

    if (request) {
      // Forter token is exposed from mustache template
      if (15 < request.length) {
        const requestPayload = {
          ...payload,
          fc_token: window.fcToken
        };
        return dispatch(createBookingFromInquiry(request, requestPayload, accessToken));
      }
      bookingContext.messaging_thread_id = request;
    }
    const newPayload = {
      fc_token: window.fcToken,
      ...payload,
      ...bookingContext
    };
    return dispatch(createBooking(newPayload, accessToken));
  }

  checkForDuplicateBookings(startDate) {
    return new Promise((resolve, reject) => {
      const { auth, profile, listing } = this.props;
      const { accessToken } = auth;
      const listing_id = get(listing, '_id', '');
      const pendingCheckPayload = { dts_start: startDate };

      Contracts.readDuplicatePendingGuestRequests(
        pendingCheckPayload,
        profile.SSOid,
        listing_id,
        accessToken,
        (csResponse) => {
          resolve(csResponse);
          if (csResponse.error) {
            reject(csResponse.error);
          }
        }
      );
    });
  }

  requestFormErrors(err, payload, disableCta = false, reloadPage = false) {
    const modalRoot = document.getElementById('modal-container');

    if (err) {
      if (payload.feeCalcError) {
        this.setState({ processing: false });
        return $(window).scrollTop(0);
      }
      const errorHead = get(payload, 'error.message', null);
      // Payment Error
      this.errorBookingsTrack(err, payload);

      // re-enable form button
      if (!disableCta) {
        this.setState({ processing: false });
      }
      ReactDOM.render(
        <SharedIntlProviderHOC>
          <BookingsRequestModal
            errorMsg={err || false}
            errorHead={errorHead}
            success={false}
            reloadPage={reloadPage}
          />
        </SharedIntlProviderHOC>,
        modalRoot
      );
    }
  }

  handleClickNext() {
    const {
      dispatch,
      auth: { accessToken }
    } = this.props;
    const profilePath = '/v1/profiles/me';
    return Profile.read(profilePath, accessToken, (user) => {
      this.checkTransactability(user, async () => {
        return dispatch(submit(BOOKING_REQUEST_FORM));
      });
    });
  }

  handleClickBack() {
    const { flowStep, dispatch } = this.props;

    if (1 < flowStep) {
      this.props.dispatch(updateProgress(flowStep - 1));
    }
  }

  splitPaymentAnalytic(splitPaymentSelected) {
    // for test: unique event only triggered once if split payment is selected
    // and user tries to submit bkg
    const { listing, normalizedContracts } = this.props;
    const { splitCheckoutAttempted, splitFailFullAttempted } = this.state;
    const priceBreakdown = priceBreakdownObject(normalizedContracts);

    const analyticsObj = {
      listing_id: get(listing, '_id', ''),
      booking_id: get(
        normalizedContracts,
        'spaceRentalContract.booking_id',
        ''
      ),
      start_date: get(normalizedContracts, 'bookingObject.dts_start', ''),
      use_type: get(listing, 'use_type', ''),
      guest_full_payment_amount: get(priceBreakdown, 'guestPayment', '')
    };

    if (!splitCheckoutAttempted && splitPaymentSelected) {
      analyticsIntegrations.splitPaymentCheckout(analyticsObj);

      this.setState({
        splitCheckoutAttempted: true
      });
    } else if (
      splitCheckoutAttempted &&
      !splitPaymentSelected &&
      !splitFailFullAttempted
    ) {
      analyticsIntegrations.splitFailFullCheckoutSuccess(analyticsObj);

      this.setState({
        splitFailFullAttempted: true
      });
    }
  }

  handleBreadcrumbClick(step) {
    const { maxStepReached, dispatch } = this.props;
    const { processing } = this.state;
    if (maxStepReached >= step && !processing) {
      dispatch(updateProgress(step));
    }
  }

  splitPaymentChange(value, priceBreakdown, listingData, normalizedContracts) {
    const fullAmount = get(priceBreakdown, 'guestPayment', '');
    const useType = get(listingData, 'use_type', '');
    const listingId = get(listingData, '_id', '');
    const startDate = get(normalizedContracts, 'bookingObject.dts_start', '');
    const bookingId = get(
      normalizedContracts,
      'spaceRentalContract.booking_id',
      ''
    );

    if (value === 'pay_partial') {
      analyticsIntegrations.splitPaymentToggled({
        listing_id: listingId,
        booking_id: bookingId,
        guest_full_payment_amount: fullAmount,
        start_date: startDate,
        use_type: useType
      });
    }
  }

  // Calls stripe API to get PaymentMethod object depends on user input in Payment Element
  async createPaymentMethod () {
    const { stripeElements } = this.state;
    const { stripe, cardholdersName } = this.props;

    if (stripeElements) {
      stripeElements.submit();
    }
    return stripe.createPaymentMethod({
      elements: stripeElements,
      params: {
        billing_details: {
          name: cardholdersName
        }
      }
    });
  }

  // Save Stripe Elements Instance
  handleStripeElementMounted (elements) {
    this.setState({
      stripeElements: elements
    });
  }

  // Save credit card
  handlePaymentChange (card) {
    this.setState({
      selectedPayment: card
    });
  }

  // Save express payment method (google/apple pay)
  handleExpressCheckoutMethodChange (method) {
    this.setState({
      checkoutMethod: method
    });
  }

  generateCheckoutBookingInfo (extraProperties = {}) {
    const {
      number_of_guests,
      alcohol_consumed,
      are_host_rules_accepted,
      identity_verification,
      booking_use_message,
      tags,
      guest_social_events_policy_accepted
    } = get(this.props, 'bookingRequestFormValues', {});

    const {
      spaceRentalBooking: bookingObj = [],
    } = this.props;

    const activity = get(tags, 'activity', '');
    const alcoholConsumed = 'true' === alcohol_consumed;
    const schedule = this.getCurrentSchedule();

    const {
      host_id,
      guest_id,
      space_id,
      listing_id,
      duration_type,
      subtotal_amount,
      ga_client_id
    } = bookingObj;

    const attrUrl = PSSessions.Cookies('PSAttrUrl');
    const attrRef = PSSessions.Cookies('PSAttrReferrer');

    return {
      type: 'BOOKING',
      info: {
        guest_id,
        host_id,
        space_id,
        listing_id,
        duration_type,
        subtotal_amount,
        schedule,
        ga_client_id,
        are_host_rules_accepted,
        identity_verification,
        guest_social_events_policy_accepted,
        alcohol_consumed: alcoholConsumed,
        booking_use_message,
        number_of_guests,
        attr_url: attrUrl,
        attr_referrer: attrRef,
        tags: {
          activity
        },
        ...extraProperties
      }
    };
  }

  generateCheckoutPayload (bookingInfo = this.generateCheckoutBookingInfo(), extraProperties = {}) {
    const {
      addOns,
      apply_credit,
    } = get(this.props, 'bookingRequestFormValues', {});

    const {
      spaceRentalBooking: bookingObj = [],
      booking,
      selectedPaymentOption
    } = this.props;

    const bookingObjState = get(bookingObj, 'obj_state', '');
    const requestType = 'INQUIRED' === bookingObjState ? 'INQUIRY' : 'REQUEST';
    const selectedAddOns = this.getSelectedAddOns(addOns);

    const applyCreditAmount = apply_credit
      ? get(booking, 'booking.guest_payment_method_details.subtotal_ps_credit', 0)
      : 0;

    const {
      host_id,
      guest_id
    } = bookingObj;

    return {
      type: requestType,
      host_sso_id: host_id,
      guest_sso_id: guest_id,
      guest_payment_ps_credit_amount:
        'pay_partial' !== selectedPaymentOption ? applyCreditAmount : 0,
      split_payment_checkout: 'pay_partial' === selectedPaymentOption,
      items: [bookingInfo, ...selectedAddOns],
      ...extraProperties
    };
  }

  generateSetupIntentPayload (paymentMethodId) {
    const { listing, normalizedContracts, selectedPaymentOption, spaceRentalBooking } = this.props;

    const country = get(listing, 'country', '');
    const priceBreakdown = priceBreakdownObject(normalizedContracts);
    const amount = 'pay_partial' === selectedPaymentOption
      ? get(priceBreakdown, 'guestSplitPayment', 0)
      : get(priceBreakdown, 'remainingGuestTotal', 0)

    const currency = get(listing, 'prices[0].currency');
    const isInstantBooking = get(spaceRentalBooking, 'is_instant_booking', false);

    return {
      amount,
      currency,
      country,
      payment_method: paymentMethodId,
      is_instant_booking: isInstantBooking
    };
  }

  generateConfirmIntentPayload (paymentMethodId, bookingResponse) {
    const setupIntentPayload = this.generateSetupIntentPayload(paymentMethodId);
    const { selectedPaymentOption } = this.props;

    const amount = 'pay_partial' === selectedPaymentOption
      ? bookingResponse?.master?.calculations?.guest?.split_payment?.parts?.[0]
      : bookingResponse?.guest_payment_method_details?.subtotal_remaining;

    // Payload is the same as for setup intent but amount should be taken from contracts here
    return {
      ...setupIntentPayload,
      amount
    };
  }


  // API call to our backend to get intent object
  // Returns undefined if paymentMethodId is missing or amount to pay is 0
  async createSetupIntent (paymentMethodId) {
    const { profile, auth, normalizedContracts } = this.props;

    const priceBreakdown = priceBreakdownObject(normalizedContracts);
    const remainingGuestTotal = get(priceBreakdown, 'remainingGuestTotal');

    // Skip intent creation if amount to pay is 0
    if (!paymentMethodId || 0 === remainingGuestTotal) {
      return;
    }

    const ssoId = get(profile, 'SSOid', '');
    const accessToken = get(auth, 'accessToken', '');

    const payload = this.generateSetupIntentPayload(paymentMethodId);

    return new Promise((resolve, reject) => {
      Payments.createSetupIntent(ssoId, accessToken, payload, (response) => {
        if (200 === response.statusCode) {
          return resolve(response);
        }
        reject(response);
      });
    });
  }

  // API call to our backend to confirm intent
  // Skips its execution if paymentMethodId or intentId are missing
  async confirmIntent (paymentMethodId, intentId, bookingResponse) {
    if (!paymentMethodId || !intentId) {
      return;
    }

    const { profile, auth } = this.props;

    const ssoId = get(profile, 'SSOid', '');
    const accessToken = get(auth, 'accessToken', '');

    const payload = this.generateConfirmIntentPayload(paymentMethodId, bookingResponse);

    return new Promise((resolve, reject) => {
      Payments.confirmIntent(ssoId, intentId, accessToken, payload, (response) => {
        if (200 === response.statusCode) {
          return resolve(response);
        }
        reject(new Error(response?.error?.raw?.message));
      });
    });
  }

  // Returns paymentMethodId depending on whether a new or existing card is selected
  async getSelectedPaymentMethodId () {
    const { intl, normalizedContracts } = this.props;
    const { selectedPayment, checkoutMethod, paymentInfo } = this.state;

    const priceBreakdown = priceBreakdownObject(normalizedContracts);
    const remainingGuestTotal = get(priceBreakdown, 'remainingGuestTotal', '');
    const isFullCreditsPayment = 0 === remainingGuestTotal;
    const isCreditCardPayment = !checkoutMethod || checkoutMethod === 'card';

    // Checkout with an existing user's card
    if ((isCreditCardPayment && selectedPayment) || isFullCreditsPayment) {
      const defaultPayment = get(paymentInfo, [0]);
      const card = selectedPayment || defaultPayment;
      const paymentMethodId = get(card, 'id', '');

      if (!paymentMethodId) {
        throw new Error(intl.formatMessage({...reloadErrorMeta}));
      }

      return paymentMethodId;
    }

    // Checkout with new payment info from stripe element (new card, apple/google pay etc.)
    const paymentMethodResponse = await this.createPaymentMethod();
    const paymentMethodId = get(paymentMethodResponse, 'paymentMethod.id');
    const errorMsg = get(paymentMethodResponse, 'error.message', 'Please try correcting your card details and then resubmit.');
    if (paymentMethodResponse.error) {
      throw new Error(errorMsg);
    }

    return paymentMethodId;
  }

  async sendRequest () {
    // Steps:
    // 1. Check transactability
    // 2. Save billing address
    // 3. Get payment method ID (get from existing card or create a new method from stripe element)
    // 4. Create setup intent
    // 5. Post booking
    // 6. Confirm intent
    // 7. submitCB (auth polling)

    // Start checkout process
    this.setState({ processing: true });

    const { profile } = this.props;

    this.checkTransactability(profile, async () => {
      const { booking, submitCB } = this.props;
      const { showBillingForm } = this.state;

      // Check for quote errors
      const feeCalcError = get(booking, 'error', '');
      if (!isEmpty(feeCalcError)) {
        return this.requestFormErrors('Please correct your dates', {
          feeCalcError: true,
          processing: false
        });
      }

      // Update billing address in case there were some changes
      if (showBillingForm) {
        try {
          await this.submitUpdateBillingAddress();
        } catch (e) {
          // Update Billing Address Error
          return this.setState({ processing: false });
        }
      }

      // Send segment call regardless of success or error
      this.loadBookingsTrack('booking request attempt');

      try {
        // Get paymentMethodId depending on whether a new or existing card is selected
        const paymentMethodId = await this.getSelectedPaymentMethodId();

        try {
          // Create setup intent using payment method (existing card or new payment option)
          const setupIntentResponse = await this.createSetupIntent(paymentMethodId);
          const intentId = get(setupIntentResponse, 'id');
          // BE might have stored this method before so we need to use it instead
          // Otherwise keep using newly generated
          const newPaymentMethodId = get(setupIntentResponse, 'payment_method') || paymentMethodId;

          try {
            // Send a booking request
            const bookingInfo = this.generateCheckoutBookingInfo({
              guest_payment_card_id: newPaymentMethodId
            });
            const payload = this.generateCheckoutPayload(bookingInfo, {
              payment_intent_id: intentId
            });
            const { response } = await this.postBooking(payload);
            const bookingContract = find(response.children, { type: 'SPACE_RENTAL' });
            const responseBooking = get(bookingContract, 'meta.booking');

            try {
              // Confirm intent using payment method and intent id
              // Skips its execution if paymentMethodId or intentId are missing
              await this.confirmIntent(newPaymentMethodId, intentId, response);

              // Send segment call in case of success
              this.successBookingsTrack(response);
            } catch (error) {
              // Confirm Intent Error
              this.errorBookingsTrack(error?.message ?? error, responseBooking);
            } finally {
              // Start cc auth polling even if the confirmIntent request failed
              submitCB(responseBooking, true);
            }
          } catch (error) {
            // Post Booking Error
            return this.requestFormErrors(error?.message ?? error, {}, true, true);
          }
        } catch (error) {
          // Create Setup Intent Error
          return this.requestFormErrors(error?.message ?? error, {}, true, true);
        }
      } catch (error) {
        // Get Selected Payment Method ID Error
        this.setState({ processing: false });
        return this.requestFormErrors(error?.message ?? error, {}, false, false);
      }
    }, () => {
      this.setState({ processing: false });
    })
  }

  render() {
    const {
      meetsMaxAttendees,
      paymentInfo,
      processing,
      showSkeleton,
      selectedPayment,
      showAttendeeIBWarning,
      credits,
      creditsFetched,
      applyCreditProcessing,
      guestNeedsVerification,
      allCountries,
      globalCountries,
      riskScore,
      splitPaymentProcessing,
      splitPaymentPermitted
    } = this.state;

    const {
      listing = {},
      booking = {},
      inventory,
      spaceRentalBooking,
      profile,
      masterBookingContract,
      addOnsContracts,
      addOnInventoryData = [],
      flowStep,
      normalizedContracts,
      activityValue,
      params,
      alcoholConsumed,
      maxStepReached,
      env,
      billingCountryValue,
      intl
    } = this.props;

    const bookingDetails =
      get(normalizedContracts, 'bookingObject') || booking.booking;
    const isInstaBooking = get(spaceRentalBooking, 'is_instant_booking', false);
    const isInstaBookingWithValidAttendees =
      isInstaBooking && meetsMaxAttendees;
    const bookingSummaryObj = !isEmpty(spaceRentalBooking)
      ? spaceRentalBooking
      : get(booking, 'booking', {});
    const currency = get(listing, 'prices[0].currency');
    const guestPaymentTotal = get(
      normalizedContracts,
      'masterContract.calculations.guest.payment'
    );
    const socialEventPolicyAgreementRequired = get(
      normalizedContracts,
      'spaceRentalContract.meta.risk.guest_social_events_policy_agreement_required',
      false
    );
    const { SSOid } = profile;
    const totalSteps = addOnInventoryData.length ? 3 : 2;
    const isMobile = 'mobile' === get(params, 'mobile', '');
    const isDataLoading =
      (isMobile
        ? isEmpty(listing) || isEmpty(inventory.data)
        : isEmpty(bookingSummaryObj) ||
          isEmpty(listing) ||
          isEmpty(inventory.data)) || !creditsFetched;

    const breadCrumbSteps = [
      {
        step: 1,
        disabled: 1 > maxStepReached,
        text: this.props.intl.formatMessage({
          id: 'booking_request.main.booking_details',
          defaultMessage: 'Booking Details'
        })
      },
      ...(addOnInventoryData.length
        ? [
            {
              step: 2,
              disabled: 2 > maxStepReached,
              text: this.props.intl.formatMessage({
                id: 'booking_request.main.add_ons',
                defaultMessage: 'Add-ons'
              })
            },
            {
              step: 3,
              disabled: 3 > maxStepReached,
              text: this.props.intl.formatMessage({
                id: 'booking_request.main.review',
                defaultMessage: 'Review'
              })
            }
          ]
        : [
            {
              step: 2,
              disabled: 2 > maxStepReached,
              text: this.props.intl.formatMessage({
                id: 'booking_request.main.review',
                defaultMessage: 'Review'
              })
            }
          ])
    ];

    const activityDetailBooking = cloneDeep(bookingDetails);
    if (!isEmpty(activityDetailBooking)) {
      activityDetailBooking.payment = {};
      activityDetailBooking.list_price = {};
      activityDetailBooking.payout = {};
      activityDetailBooking.view_as = 'GUEST';
      activityDetailBooking.attendees = activityDetailBooking.number_of_guests;
      activityDetailBooking.listing = listing;
      activityDetailBooking.tags = get(activityValue, 'tags', {});
      set(activityDetailBooking, 'guest.sso_id', get(booking, 'guest.ssoid'));
    }
    const policies = get(env, 'web.social_events_policy', []);

    return (
      <div className='bookings-request-body'>
        <SharedIntlProviderHOC>
          {isDataLoading ? (
            <div className='spinner-container page-spinner'>
              <PageSpinner />
            </div>
          ) : (
            <>
              <div className='ps-container-lg-margin ps-container-fixed'>
                <div className='ps-row'>
                  <div className='col-xs-12 col-lg-7'>
                    <Breadcrumb
                      currentStep={flowStep}
                      steps={[...breadCrumbSteps]}
                      onClick={this.handleBreadcrumbClick}
                    />

                    <BookingRequestForm
                      {...this.props}
                      handleStripeElementMounted={this.handleStripeElementMounted}
                      paymentInfo={paymentInfo}
                      handlePaymentChange={this.handlePaymentChange}
                      handleExpressCheckoutMethodChange={this.handleExpressCheckoutMethodChange}
                      selectedPayment={selectedPayment}
                      sendRequest={this.sendRequest}
                      showConfirmButton={!!this.state.controlId}
                      listingData={listing}
                      isSubmitting={processing}
                      isInstaBookingWithValidAttendees={
                        isInstaBookingWithValidAttendees
                      }
                      schedule={this.getCurrentSchedule()}
                      getCurrentSchedule={this.getCurrentSchedule}
                      getFeeCalc={this.getFeeCalc}
                      handleAttendeesChange={this.handleAttendeesChange}
                      showAttendeeIBWarning={showAttendeeIBWarning}
                      addOns={addOnInventoryData}
                      handleAddOnChange={this.handleAddOnChange}
                      ssoId={SSOid}
                      updateProgress={updateProgress}
                      totalSteps={totalSteps}
                      normalizedContracts={normalizedContracts}
                      handleClickBack={this.handleClickBack}
                      masterContract={masterBookingContract}
                      activityDetailBooking={activityDetailBooking}
                      hideFeeCalc={
                        'mobile' === get(params, 'mobile') &&
                        isEmpty(spaceRentalBooking)
                      }
                      loadBookingsTrack={this.loadBookingsTrack}
                      credits={credits}
                      handleApplyCreditChange={this.handleApplyCreditChange}
                      applyCreditProcessing={applyCreditProcessing}
                      socialEventPolicyAgreementRequired={
                        socialEventPolicyAgreementRequired
                      }
                      socialEventsPolicyCopy={policies}
                      guestNeedsVerification={guestNeedsVerification}
                      alcoholConsumed={alcoholConsumed}
                      allCountries={allCountries}
                      globalCountries={globalCountries}
                      riskScore={riskScore}
                      handleBillingCountryChange={
                        this.handleBillingCountryChange
                      }
                      handleBillingSubRegionChange={
                        this.handleBillingSubRegionChange
                      }
                      splitPaymentAnalytic={this.splitPaymentAnalytic}
                      splitPaymentChange={this.splitPaymentChange}
                      splitPaymentProcessing={splitPaymentProcessing}
                      splitPaymentPermitted={splitPaymentPermitted}
                    />
                  </div>

                  {flowStep !== totalSteps ? (
                    <div className='col-xs-12 col-lg-5 padding-xl-top'>
                      <BookingRequestSummary
                        booking={bookingSummaryObj}
                        profile={profile}
                        showSkeleton={showSkeleton}
                        listing={listing}
                        addOnsContracts={addOnsContracts}
                        masterContract={masterBookingContract}
                        intl={intl}
                      />
                    </div>
                  ) : (
                    <div className='d-xs-none d-lg-block col-xs-12 col-lg-5 padding-xl-top'>
                      <BookingSummary
                        booking={activityDetailBooking}
                        profile={profile}
                        showSkeleton={showSkeleton}
                        intl={intl}
                      />
                    </div>
                  )}
                </div>
              </div>
              {flowStep !== totalSteps && (
                <div className='sticky-footer-wrap'>
                  <StickyFooter className='ps-container-lg-margin ps-container-fixed flex middle'>
                    <div className='ps-row flex-one'>
                      <div className='col-xs-12 flex space-between'>
                        {flowStep !== 1 && (
                          <Button
                            type='button'
                            className='btn btn-default classic'
                            onClick={this.handleClickBack}
                          >
                            Back
                          </Button>
                        )}

                        <div
                          className='flex middle'
                          style={{ marginLeft: 'auto' }}
                        >
                          {params?.mobile === 'mobile' &&
                            !isEmpty(spaceRentalBooking) && (
                              <div className='heavy margin-lg-right d-sm-none'>
                                <FormattedNumber
                                  value={guestPaymentTotal}
                                  currency={currency}
                                  style={'currency'}
                                />
                              </div>
                            )}
                          <Button
                            type='submit'
                            attributes={{
                              'data-testing-id': 'booking-details-next-btn'
                            }}
                            style={{ justifySelf: 'flex-end' }}
                            category='primary'
                            onClick={this.handleClickNext}
                            className='btn-black'
                          >
                            <FormattedMessage
                              id='inbox_guest_update_booking.update_booking_guest_main.next_button'
                              defaultMessage='Next'
                            />
                          </Button>
                        </div>
                      </div>
                    </div>
                  </StickyFooter>
                </div>
              )}
            </>
          )}
        </SharedIntlProviderHOC>
      </div>
    );
  }
}

const selector = formValueSelector(BOOKING_REQUEST_FORM);

function mapStateToProps(state, ownProps) {
  const {
    parsedSchedule,
    getInitialScheduleVals,
    noAuthBooking,
    noAuthContracts
  } = ownProps;
  const {
    booking,
    listing,
    auth,
    profile,
    inventory,
    flow,
    feeProfiles,
    env,
    spaces,
    space
  } = state;

  // no auths
  const spaceRentalContract =
    find(noAuthContracts, { type: 'SPACE_RENTAL' }) || [];
  const noAuthBookingContract = get(spaceRentalContract, 'meta.booking', {});

  const listingData = get(listing, 'data', {});
  const scheduleValues = selector(state, 'schedule');
  const numberGuestsValue = selector(state, 'number_of_guests');
  const addOnsValues = selector(state, 'addOns', []);
  const activityValue = selector(state, 'tags', {});
  const identityValue = selector(state, 'identity', {});
  const applyCreditValue = selector(state, 'apply_credit', {});
  const alcoholConsumed = selector(state, 'alcohol_consumed');
  const normalizedContracts = normalizeContracts(get(booking, 'booking'), {});
  const billingCountryValue = selector(state, 'billing_country');
  const billingStateValue = selector(state, 'billing_state');
  const billingCityValue = selector(state, 'billing_city');
  const billingStreetValue = selector(state, 'billing_street');
  const billingUnitValue = selector(state, 'billing_unit');
  const billingZipValue = selector(state, 'billing_zip');
  const selectedPaymentOption = selector(state, 'split_payment');
  const guestSocialEventsPolicyAccepted = selector(state, 'guest_social_events_policy_accepted');
  const cardholdersName = selector(state, 'cardholders_name');

  const parsedUrl = parseQueryString(location.search);
  const { request } = parsedUrl;
  const isExistingBooking = request && 0 < request.length;

  // if 'request' query param is missing use the schedule from cookie
  const finalSchedule =
    !isExistingBooking
      ? parsedSchedule
      : get(booking, 'booking.schedule') || normalizedContracts.bookingObject;

  const inventoryData = get(inventory, 'data.inventory', []);
  const publicAddOns =
    filter(inventoryData, { visible_on_listing: true }) || [];
  const schedObj = get(
    normalizedContracts,
    'bookingObject.schedule[0].start.date',
    {}
  );

  const bookingStart = moment(
    schedObj.m + '-' + schedObj.d + '-' + schedObj.y,
    'MM-DD-YYYY'
  );

  const hostAddOns = filter(inventoryData, (addOn) => {
    return !addOn.is_concierge;
  });

  // show concierge items if booking is within 2 business days
  const showConciergeItems = 2 <= business.weekDays(moment(), bookingStart);

  const addOnInventoryData = showConciergeItems ? inventoryData : hostAddOns;
  // add selected add-ons for no auth retry
  const noAuthBookingAddOns = filter(noAuthContracts, { type: 'ITEM' });
  const addOns = map(addOnInventoryData, (item) => {
    if (item.visible_on_listing) {
      const addedItem = find(noAuthBookingAddOns, { item_id: item._id });
      return {
        type: 'ITEM',
        info: {
          item_id: item._id,
          max_count: item.count,
          ...(addedItem && { count: addedItem.units })
        }
      };
    }
  });

  const addOnsCategories = get(env, 'addOns.categories', []);
  const billingAddress = get(feeProfiles, 'billingAddress.data', []);
  const guestSpaceCountry = get(space, 'data.countryStatus.country', '');
  const locale = SharedIntlProviderHOC.getLocale();
  const localeCountry = locale.split('-')[1];
  const isLocaleCanada = 'CA' === localeCountry;

  const riskScore = get(
    find(get(booking, 'booking.children'), { type: 'SPACE_RENTAL' }),
    'meta.risk.risk_score'
  );
  const bookingRequestFormValues = getFormValues(BOOKING_REQUEST_FORM)(state);

  const activeBillingAddress = find(billingAddress, (address) => {
    return 'ACTIVE' === address.obj_state;
  }) || {};

  const initialActivity = get(noAuthBookingContract, 'tags.activity', '')
  const initialTags = noAuthBooking ? { activity: initialActivity } : {};

  return {
    auth,
    profile,
    booking,
    inventory,
    listing: listingData,
    initialValues: {
      tags: initialTags,
      scheduleInput: !isEmpty(getInitialScheduleVals(finalSchedule))
        ? getInitialScheduleVals(finalSchedule)
        : [{}],
      schedule: !isEmpty(finalSchedule) ? finalSchedule : [{}],
      addOns,
      alcohol_consumed: noAuthBooking
        ? noAuthBookingContract.alcohol_consumed
          ? 'true'
          : 'false'
        : null,
      number_of_guests: noAuthBookingContract.number_of_guests || null,
      booking_use_message: noAuthBookingContract.booking_use_message || null,
      apply_credit: false,
      split_payment: 'pay_full',
      billing_country: activeBillingAddress.country || guestSpaceCountry || localeCountry,
      billing_city: activeBillingAddress.city,
      billing_state: activeBillingAddress.state,
      billing_street: activeBillingAddress.street,
      billing_unit: activeBillingAddress.unit,
      billing_zip: activeBillingAddress.zip
    },
    scheduleValues,
    numberGuestsValue,
    activityValue,
    identityValue,
    applyCreditValue: applyCreditValue,
    spaceRentalContract: normalizedContracts.spaceRentalContract,
    spaceRentalBooking: normalizedContracts.bookingObject,
    masterBookingContract: normalizedContracts.masterContract,
    addOnsContracts: normalizedContracts.items,
    addOnsValues: addOnsValues.addOns,
    addOnInventoryData,
    publicAddOns,
    hostAddOns,
    inventoryData,
    flowStep: get(flow, 'step') || 1,
    maxStepReached: get(flow, 'maxStepReached') || 1,
    normalizedContracts: normalizedContracts,
    noAuthBookingContract,
    addOnsCategories,
    alcoholConsumed,
    feeProfiles,
    spaces,
    billingCountryValue,
    billingStateValue,
    billingCityValue,
    billingStreetValue,
    billingUnitValue,
    billingZipValue,
    guestSpaceCountry,
    riskScore,
    selectedPaymentOption,
    bookingRequestFormValues,
    guestSocialEventsPolicyAccepted,
    cardholdersName
  };
}

BookingsRequestMain.propTypes = {
  auth: PropTypes.object,
  params: PropTypes.object.isRequired,
  profile: PropTypes.object.isRequired,
  schedule: PropTypes.array,
  booking: PropTypes.object,
  spaceRentalBooking: PropTypes.object,
  spaceRentalContract: PropTypes.object,
  masterBookingContract: PropTypes.object,
  addOnsContracts: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  services: PropTypes.object,
  submitCB: PropTypes.func,
  getGAExperiments: PropTypes.func,
  listing: PropTypes.object,
  inventory: PropTypes.object,
  publicAddOns: PropTypes.array,
  spaceRental: PropTypes.object,
  addOnInventoryData: PropTypes.array,
  flowStep: PropTypes.number,
  maxStepReached: PropTypes.number,
  normalizedContracts: PropTypes.object,
  activityValue: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  addOnsCategories: PropTypes.array
};

export default injectIntl(connect(mapStateToProps)(withStripeInstance(BookingsRequestMain)));
